import { NgModule } from '@angular/core';

import { AuthAccountBalanceModule } from './authAccountBalance';
import { AuthBackModule } from './authBack';
import { AuthBalanceModule } from './authBalanceValue';
import { AuthDeleteAccountModule } from './authDeleteAccount';
import { AuthDescriptionModule } from './authDescription';
import { AuthFooterModule } from './authFooter';
import { AuthHeaderModule } from './authHeader';
import { AuthLinkModule } from './authLink';
import { AuthWrapperModule } from './authWrapper';

const toExport: any[] = [
    AuthAccountBalanceModule,
    AuthBackModule,
    AuthBalanceModule,
    AuthDeleteAccountModule,
    AuthDescriptionModule,
    AuthFooterModule,
    AuthHeaderModule,
    AuthLinkModule,
    AuthWrapperModule,
];

@NgModule({
    imports: [
        ...toExport,
    ],
    exports: [
        ...toExport,
    ],
})
export class AuthComponentsModule { }
